exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-dropzone[data-v-486ecf08] {\n\tborder: 2px dashed #e5e5e5;\n}\n", ""]);

// exports
